import { useCallback, useEffect, useState } from "react";

/**
 * Mecânica compartilhada pelas abas de estoque (saídas e entradas): busca com
 * debounce, carregamento e paginação no cliente. As abas mudam só as colunas,
 * então só o `fetcher` varia.
 *
 * `fetcher` precisa ser estável (useCallback), senão o efeito de carga dispara
 * a cada render.
 */
export default function useEstoqueLista(fetcher, unidadeDistribuidoraId, searchTerm) {
	const [itens, setItens] = useState([]);
	const [loading, setLoading] = useState(true);
	const [page, setPage] = useState(0);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [busca, setBusca] = useState(searchTerm);

	// Evita uma requisição por tecla digitada.
	useEffect(() => {
		const timeoutId = setTimeout(() => {
			setBusca(searchTerm);
			setPage(0);
		}, 500);

		return () => clearTimeout(timeoutId);
	}, [searchTerm]);

	const load = useCallback(async () => {
		if (!unidadeDistribuidoraId) return;

		setLoading(true);
		try {
			const result = await fetcher(unidadeDistribuidoraId, busca || undefined);
			setItens(result || []);
		} catch (error) {
			console.error("Erro ao carregar estoque:", error);
			alert(error.message || "Erro ao carregar estoque");
		} finally {
			setLoading(false);
		}
	}, [fetcher, unidadeDistribuidoraId, busca]);

	useEffect(() => {
		load();
	}, [load]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const itensPaginados = itens.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

	return {
		itens,
		itensPaginados,
		loading,
		page,
		rowsPerPage,
		handleChangePage,
		handleChangeRowsPerPage,
	};
}
